





























































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'

settings =
  name: 'ReportingServicePage'
  components: { SuperContainerView }
  resources:
    report_stream:
      resourceName: 'report_stream'
      slug: 'report_stream'
      infinityScroll: false
      params:
        per_page: 1000


  vue:
    data: ->
      activeName: "1"
      selectedReports: []
      selectedAnnualReports: []
      reportGenerationBaseList:
        [
          { name: "Event", type: "event" },
          { name: "Campaign", type: "campaign" },
          { name: "Purchase Order", type: "purchase_order" },
          { name: "Invoice", type: "invoice" },
          { name: "Remittance", type: "remittance" },
          { name: "Accepted Offers", type: "accepted_offers" },
          { name: "Offer Metrics", type: "offer_metrics" },
          { name: "Offer Tracking", type: "offer_tracking" },
        ]

    computed: 
      reportStream: -> @report_stream || []

      reportTypes: ->
        types = {}
        types[report.type] = true for report in @reportStream
        Object.keys(types)

    methods:
      hiGenerateReport: ->
        @triggerResource('report_stream', 'stream_reports', { types: @selectedReports })

      hiGenerateAnnualReport: ->
        @triggerResource('report_stream', 'stream_annual_reports', { types: @selectedAnnualReports })

      reportButtonText: (reportsArray) ->
        return "Generate Reports" if reportsArray.length > 1
        "Generate Report"

      syncReportGenerationList: ->
        for report in @report_stream
          item = @reportGenerationBaseList.find((obj) => obj.type == report.type)
          if item
            item.sheet_id = report.spreadsheet_id
          else
            @reportGenerationBaseList.push({name: report.type, type: report.type })

    watch:
      report_stream: ->
        @syncReportGenerationList()

export default VueOptions.vue settings
